module.exports = __webpack_public_path__ + "static/vmware_19.e5620549.jpg";